var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"ellipse-element-1",attrs:{"src":require("../assets/images/ellipse-element.svg"),"alt":"ellipse"}}),_c('div',{staticClass:"main-screen__container"},[_c('header-toolbar')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }